module.exports = __webpack_public_path__ + "media/13.d58c4f77.mp3";